import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  NgcCookieConsentService,
  NgcStatusChangeEvent,
} from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private router = inject(Router);
  private ccService = inject(NgcCookieConsentService);
  private statusChangeSubscription?: Subscription;
  private navigationSubscription?: Subscription;
  private readonly analyticsId = 'G-H13EV9DTN9';
  private trackingEnabled = false;
  private lastTrackedPath?: string;

  init() {
    if (this.ccService.hasConsented()) {
      this.enableTracking();
      return;
    }

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        if (event.status === 'dismiss') {
          this.enableTracking();
        }
      },
    );
  }

  private enableTracking() {
    if (this.trackingEnabled) {
      return;
    }

    gtag('consent', 'update', { analytics_storage: 'granted' });
    this.trackingEnabled = true;

    this.trackPageView(this.router.url);

    this.navigationSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.trackPageView(event.urlAfterRedirects);
      });

    this.statusChangeSubscription?.unsubscribe();
    this.statusChangeSubscription = undefined;
  }

  private trackPageView(pagePath: string) {
    if (!pagePath || this.lastTrackedPath === pagePath) {
      return;
    }

    gtag('config', this.analyticsId, {
      page_path: pagePath,
    });
    this.lastTrackedPath = pagePath;
  }
}
